var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{class:_vm.$vuetify.theme.dark ? undefined : 'grey lighten-3',attrs:{"id":"pages"}},[_c('v-responsive',{staticClass:"align-center d-flex",style:(_vm.styles),attrs:{"height":"100vh"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }